export default [
  {
    path: '/activity-lottery',
    component: () => import('@/views/activity/lottery/Index.vue'),
    name: 'activity.lottery',
    meta: {
      title: '抽奖',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/activity-groupRide',
    component: () => import('@/views/activity/groupRide/Index.vue'),
    name: 'activity.groupRide',
    meta: {
      backgroundClass: 'bg-white',
      title: '组队骑行',
    },
  },
  {
    path: '/activity-magicbox',
    component: () => import('@/views/activity/magicbox/Index.vue'),
    name: 'activity.magicbox',
    meta: {
      title: '试驾摩盒',
      backgroundClass: 'bg-magicbox',
    },
    hidden: true,
  },
  {
    path: '/activity-signin',
    component: () => import('@/views/activity/signin/Index.vue'),
    name: 'activity.signin',
    meta: {
      title: '连续签到抽盲盒',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/activity-signin-record',
    component: () => import('@/views/activity/signin/DrawRecord.vue'),
    name: 'activity.signin.record',
    meta: {
      title: '抽奖记录',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },

  {
    path: '/activity-draw',
    component: () => import('@/views/activity/draw/Draw.vue'),
    name: 'activity.draw',
    meta: {
      title: '整车抽奖',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/activity-draw-rule',
    component: () => import('@/views/activity/draw/Rule.vue'),
    name: 'activity.draw.rule',
    meta: {
      title: '活动规则',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/activity-draw-record',
    component: () => import('@/views/activity/draw/Record.vue'),
    name: 'activity.draw.record',
    meta: {
      title: '抽奖记录',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  // 新车预约
  {
    path: '/activity-reservation',
    component: () => import('@/views/activity/reservation/Index.vue'),
    name: 'activity.reservation',
    meta: {
      title: '新车列表',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/activity-reservation-detail-:id',
    component: () => import('@/views/activity/reservation/Detail.vue'),
    name: 'activity.reservation.detail',
    meta: {
      title: '新车预约',
      backgroundClass: 'bg-gray',
      keepAlive: true,
    },
    hidden: true,
  },
  {
    path: '/activity-reservation-rule-:id',
    component: () => import('@/views/activity/reservation/Rule.vue'),
    name: 'activity.reservation.rule',
    meta: {
      title: '活动细则',
      backgroundClass: 'bg-white',
    },
    hidden: true,
  },
  {
    path: '/activity-reservation-record-:id',
    component: () => import('@/views/activity/reservation/Record.vue'),
    name: 'activity.reservation.record',
    meta: {
      title: '中奖记录',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
];
